import { render, staticRenderFns } from "./StatisticsProgramType.vue?vue&type=template&id=3becf1c6&"
import script from "./StatisticsProgramType.vue?vue&type=script&lang=js&"
export * from "./StatisticsProgramType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports